<template>
    <div class="query shadow mb-3 p-4">
        <div class="row">
            <div class="col-5 container">
                <div class="row" >
                    <div class="col-md-12 checkbox-radios">
                        <base-checkbox :checked="localQuery.active" v-model="localQuery.active" inline @input="updateProp('active', $event)">спрашивать</base-checkbox>
                    </div>
                </div>
                <div class="row">
                    <label class="col-form-label col-md-12"> <span>Вопрос:</span></label>
                    <div class="col-md-12">
                        <div class="form-group">
                            <div class="mb-0">
                                <textarea class="form-control" rows="9" :value="localQuery.text" @change="updateProp('text', $event.target.value)"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="query-props col-6">
                <REAIQueryFilters 
                    v-model="localQuery.filters"
                    :filterProps="filterProps"
                />
                <REAIQueryProps v-model="localQuery.props"/>
            </div>
            <div class="col-1">
                <div>
                    <base-button class="btn btn-danger w-100" type="danger" simple @click="removeQuery()">Удалить вопрос</base-button>
                </div>
                <div>
                    <base-button class="btn btn-warning w-100" type="warning" simple  @click="copyQuery()">Дублировать</base-button>
                </div>
            </div>
        </div>
        <!--
        <div>
            {{ JSON.stringify(localQuery) }}
        </div>
        -->
        <!--
        <div class="prewrap ai-query" v-show="localQuery.text>''">
            {{ JSON.stringify(formatQuery) }}
        </div>
        -->
    </div>
</template>

<script>
import REAIQueryProps from './REAIQueryProps.vue';
import REAIQueryFilters from './REAIQueryFilters.vue';

import { BaseCheckbox } from 'src/components/index';

export const formatQueryObject=(props)=>{
    // console.log('formatQueryObject', props);
    let pr = props.filter(p=>p.name>'');
    // console.log(pr);
    if(pr.length>0){
        let f={type:'object', properties:{}, required:[]}
        pr.forEach(p=>{
            f.properties[p.name]=propsType(p.type, p);
            if(p.required) f.required.push(p.name);
        })
        if(f.required.length==0) delete f.required;
        // console.log('format',f);
        return f;
    }
    return {}
}

export const formatQuery=(q,prompt='')=>{
    // console.log('formatrQuery',q);
    let r={
        message:{role:'user', content:q.text},
        // num_ctx:8192
    }
    if(prompt>'') r.message.content+=' '+prompt;
    if(q.filters){
        let f = q.filters.filter(p=>p.name.trim()>''&&p.value.trim()>'');
        if(f.length>0){
            r.filters={};
            f.forEach(filter=>r.filters[filter.name.trim()]=filter.value.split(',').map(t=>t.trim()))
        }
    }
    /*
    let pr = q.props.filter(p=>p.name>'');
    if(pr.length>0){
        let f={type:'object', properties:{}, required:[]}
        pr.forEach(p=>{
            f.properties[p.name]=propsType(p.type, p);
            if(p.required) f.required.push(p.name);
        })
        if(f.required.length==0) delete f.required;
        r.format = f;
    }
    */
    r.format=formatQueryObject(q.props)
    // console.log('return',r);
    return r;
}
export const propsType=(type,p)=>{
    // console.log('propttype',type,p);
    switch(type){
        case 'arrayString': return {type:'array', items:{type:'string'}};
        case 'arrayInt': return {type:'array', items:{type:'integer'}};
        case 'date': return {type:'string', format:'date'};
        case 'datetime': return {type:'string', format:'datetime',
            // "pattern": "^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$"
        };
        case 'time': return {type:'string', format:'time',"pattern": "^[0-9]?[0-9]:[0-5]?[0-9]:[0-5]?[0-9](\\.[0-9]+)?$"};
        case 'enum': return {type:'string', enum:String(p.enum).split(',').map(v=>v.trim())};
        case 'arrayEnum': return {type:'array', items:{type:'string', enum:String(p.enum).split(',').map(v=>v.trim())}};
        case 'object': return formatQueryObject(p.props||[]);
        case 'arrayObject': return {type:'array', items:formatQueryObject(p.props||[])};
        // ,"format":{"type":"object","properties":{"Адрес":{"type":"object","format":{"type":"object","properties":{"Улица":{"type":"string"},"Дом":{"type":"string"},"Район":{"type":"string"}},"required":["Улица","Дом","Район"]}}},"required":["Адрес"]}}
    }
    return {type}
}

export default{
    components:{
        REAIQueryProps,
        REAIQueryFilters,
        BaseCheckbox,
    },
    props:{
        query:{ 
            type: Object,
            required: true,
        },
        prompt:{
            type: String,
            default:'',
        },
        filterProps:{
            type: Array,
            default(){ return []},
        }
    },
    data(){
        return {
            localQuery: { ...this.query }
        }
    },
    watch: {
        // Если родитель обновляет prop `text` извне — синхронизируем локальную копию
        query: {
            handler(newVal) {
                this.localQuery = { ...newVal };
            },
            deep: true // важно для отслеживания изменений внутри объекта
        },
        formatQuery(newVal,oldVal){
            if(JSON.stringify(newVal)!=JSON.stringify(oldVal)){
                // console.log(newVal,oldVal);
                this.handleChange();
            }
        }
    },
    computed:{
        formatQuery(){
            return formatQuery(this.localQuery, this.prompt)
        },
    },
    methods:{
        copyQuery(){
            this.$emit('clone', this.localQuery);
        },
        removeQuery() {
            this.$emit('remove', this.localQuery); 
        },
        updateProp(prop, value){
            this.localQuery[prop] = value;
            // console.log(this.localQuery,prop,value);
            this.handleChange();
        },
        handleChange(){
            this.$emit('change', { ...this.localQuery });
        }        
    }
}
</script>

<style lang="scss" scoped>

</style>